// Other Info Panel - English
export default {
  tabs: {
    imtoken: "imToken Operation Info",
    tokenPocket: "TokenPocket Login Info",
    bitpie: "Bitpie Custom Tags",
  },
  loading: { text: "Loading..." },
  total: {
    prefix: "Total",
    suffix: "records",
  },
  actions: {
    download: "Download",
  },
  table1: {
    operationType: "Operation Type",
    operationTypeExplain: "Operation Type Description",
    ip: "IP Address",
    ipGeo: "IP Geolocation",
    operateTime: "Operation Time",
  },
  table2: {
    loginDevice: "Login Device",
    ipAddress: "IP Address",
    port: "Port",
    ipGeo: "IP Geolocation",
    operateTime: "Operation Time",
  },
  dialog: {
    titleImTokenExplain: "imToken Wallet Operation Types",
  },
  empty: "No data",
  downloadFileName: "TokenPocket Login Info",
};
